import { LearningComponentsService } from './learningComponentsService';
import { LEARNING_COMPONENTS_LIBRARY } from '../data/learningComponentsLibrary';

/**
 * Initialize Learning Components Database
 * Populates Firestore with the learning components library
 */
export const initializeLearningComponents = async () => {
  try {
    console.log('Initializing learning components database...');
    
    // Check if components already exist
    const existingComponents = await LearningComponentsService.getAllComponents();
    console.log('Existing components count:', existingComponents.length);
    
    // Check if we have the expected number of components (prevent partial initialization)
    const expectedCount = LEARNING_COMPONENTS_LIBRARY.length;
    if (existingComponents.length >= expectedCount) {
      console.log('Learning components already fully initialized. Skipping...');
      return existingComponents;
    }
    
    // If we have some components but not all, clear and reinitialize
    if (existingComponents.length > 0 && existingComponents.length < expectedCount) {
      console.log('Partial initialization detected. Clearing and reinitializing...');
      for (const component of existingComponents) {
        try {
          await LearningComponentsService.deleteComponent(component.id);
        } catch (error) {
          console.error(`Error deleting existing component ${component.id}:`, error);
        }
      }
    }
    
    // Add all components from library
    const initializedComponents = [];
    const existingNames = existingComponents.map(c => c.name);
    
    for (const component of LEARNING_COMPONENTS_LIBRARY) {
      // Skip if component already exists by name
      if (existingNames.includes(component.name)) {
        console.log(`Component already exists: ${component.name}`);
        continue;
      }
      
      try {
        const addedComponent = await LearningComponentsService.addComponent(component);
        initializedComponents.push(addedComponent);
        console.log(`Added component: ${component.name}`);
      } catch (error) {
        console.error(`Error adding component ${component.name}:`, error);
      }
    }
    
    console.log(`Successfully initialized ${initializedComponents.length} learning components`);
    return initializedComponents;
    
  } catch (error) {
    console.error('Error initializing learning components:', error);
    throw error;
  }
};

/**
 * Check if learning components are initialized
 */
export const checkLearningComponentsInitialized = async () => {
  try {
    const components = await LearningComponentsService.getAllComponents();
    return components.length > 0;
  } catch (error) {
    console.error('Error checking learning components:', error);
    return false;
  }
};

/**
 * Force reinitialize learning components (clear and reload)
 */
export const reinitializeLearningComponents = async () => {
  try {
    console.log('Reinitializing learning components...');
    
    // Get all existing components
    const existingComponents = await LearningComponentsService.getAllComponents();
    
    // Delete all existing components
    for (const component of existingComponents) {
      try {
        await LearningComponentsService.deleteComponent(component.id);
        console.log(`Deleted component: ${component.name}`);
      } catch (error) {
        console.error(`Error deleting component ${component.name}:`, error);
      }
    }
    
    // Reinitialize from library
    return await initializeLearningComponents();
    
  } catch (error) {
    console.error('Error reinitializing learning components:', error);
    throw error;
  }
};
